// extracted by mini-css-extract-plugin
export default {"shimmer":"Subscription_shimmer__Ti-wA"};